import { createAsyncThunk } from "@reduxjs/toolkit";
import { authSelectors } from "../../../auth";
import { selectChatSettings, selectChatMessages } from "../../selectors";
import { getMessagesWithReadStatusesByIndex } from "../../providers";
import { CHAT_ACTIONS } from "../../types";
import type { ActionStoreParams } from "../../../../store";
import type { Message } from "../../types";

const { selectUserId } = authSelectors;

type ActionReturn = {
  messages: Array<Message>;
  lastReadMessageIndex: number;
};

type ActionParams = {
  lastReadMessageId: string;
};

export const updateMessageStatuses = createAsyncThunk<
  ActionReturn,
  ActionParams,
  ActionStoreParams
>(
  CHAT_ACTIONS.UPDATE_MESSAGE_STATUSES,
  async ({ lastReadMessageId }, { getState }) => {
    const state = getState();
    const userId = selectUserId(state);
    const messages = selectChatMessages(state);
    const { lastReadMessageIndex } = selectChatSettings(state);
    const params = {
      messages,
      lastReadMessageIndex,
      lastReadMessageId,
      userId,
    };

    const { newMessages, newLastReadMessageIndex } =
      getMessagesWithReadStatusesByIndex(params);

    return {
      messages: newMessages,
      lastReadMessageIndex: newLastReadMessageIndex,
    };
  }
);
